import { addToast } from 'modules/messageSystem/actions/addToast';
import { removeModal } from 'modules/messageSystem/actions/removeModal';
import currentModal from 'modules/messageSystem/selectors/currentModal';
import { UNANSWERED } from 'modules/common/constants/conversationStatuses';
import { MODAL_START_CONSULTATION, APPOINTMENT_FORWARDING_CONSENT_MODAL } from 'modules/messageSystem/constants/modalCodes';
import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { stopConsultationAfterWSResponse } from 'modules/conference/actions/stopConsultation';
import { getConversationParticipantName } from 'modules/appointmentInfo/selectors/currentAppointment';
import { stopConsultationWithNoPatientAnswer } from '../stopConsultation';

export const onUnanswerParticipant = (status) => (dispatch, getState) => {
  const currModal = currentModal(getState());
  const state = getState();
  // const name = getConversationParticipantName(state)
  if (conferenceInProgress(state)) dispatch(stopConsultationAfterWSResponse(status));
  if (currModal && [MODAL_START_CONSULTATION, APPOINTMENT_FORWARDING_CONSENT_MODAL].includes(currModal.typeId)) dispatch(removeModal(currModal.id));

  // @todo restore when patient will be able to start conversation
  // return dispatch(stopConsultationWithNoPatientAnswer(UNANSWERED))
  //   .then(() => {
  //     if (!name) return;
  //
  //     dispatch(addToast('failure', 'clinician-unavailable-toast', {
  //       id: 'const.connection.clinicianIsUnavailable',
  //       defaultMessage: '** {name} is unavailable. Please try again later.',
  //       values: { name },
  //     }, false, null true, false, null, 6000, 'video'));
  //   });
};
